import { createContext } from "react";

export const CallLogPanelContext = createContext();
